import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.search) params.append("search", filters.search);
  if (filters.isActive !== undefined && filters.isActive !== "") {
    params.append("isActive", filters.isActive);
  }
  if (filters.page) params.append("page", filters.page);
  if (filters.limit) params.append("limit", filters.limit);
  return params.toString() ? `?${params.toString()}` : "";
};

export const createAcademicYearPortal = async (data) => {
  const res = await axiosInstance.post("/academic-year-portal/create", data);
  return res.data;
};

export const getAllAcademicYearsPortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/academic-year-portal/all${buildQuery(filters)}`
  );
  return res.data;
};

export const getActiveAcademicYearPortal = async () => {
  const res = await axiosInstance.get("/academic-year-portal/active");
  return res.data;
};

export const getAcademicYearByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/academic-year-portal/${id}`);
  return res.data;
};

export const updateAcademicYearPortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/academic-year-portal/update/${id}`,
    data
  );
  return res.data;
};

export const setActiveAcademicYearPortal = async (id) => {
  const res = await axiosInstance.put(
    `/academic-year-portal/set-active/${id}`
  );
  return res.data;
};
